import React, { useEffect, useState } from "react";
import { MdEmail } from "react-icons/md";
import { BsLinkedin } from "react-icons/bs";
import { FaFacebook } from "react-icons/fa";
import { Link } from "react-router-dom";
import config from "../../config/Config";
import { FaInstagramSquare } from "react-icons/fa";

function Footer() {
  const [data, setData] = useState([]);
  const currentYear = new Date().getFullYear();

  function fetchConfiguration() {
    fetch(`${config.API_BLOG}configuration`)
      .then((result) => result.json())
      .then((res) => {
        setData(res);
      })
      .catch((err) => console.error("Error fetching configuration:", err));
  }

  useEffect(() => {
    fetchConfiguration();
  }, []);

  // Safe Access
  const linkedinLink = data[0]?.linkdin_page_link;
  const Email = data[0]?.contact_email;
  const Facebook = data[0]?.facebook_page_link;
  const Instagram = data[0]?.instagram_page_link;

  return (
    <footer
      className="site-footer mt-auto background_Color"
      data-aos="fade-up"
      data-aos-duration="700"
    >
      <div className="container">
        <div className="row text_Colors font_family footer-inner align-items-center g-3 py-3">
          <div className="col-12 col-md-4 mt-md-0 mt-2">
            <div className="d-flex flex-wrap justify-content-center justify-content-md-start gap-3 gap-md-4">
              <Link to="/" style={{ textDecoration: "none" }}>
                <b className="text_Color fs-6">HOME</b>
              </Link>
              <Link to="/about" style={{ textDecoration: "none" }}>
                <b className="text_Color fs-6">ABOUT</b>
              </Link>
              <Link to="/contact" style={{ textDecoration: "none" }}>
                <b className="text_Color fs-6">CONTACT</b>
              </Link>
            </div>
          </div>

          <div className="col-12 col-md-4">
            <div className="text-center text_Color py-1">
              <b>© 2024 - {currentYear} iLearnings</b>
            </div>
          </div>

          <div className="col-12 col-md-4">
            <div className="d-flex flex-wrap justify-content-center justify-content-md-end gap-2">
              {Email ? (
                <a
                  href={`https://mail.google.com/mail/?view=cm&fs=1&to=${Email}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <MdEmail className="icne" />
                </a>
              ) : null}

              {linkedinLink ? (
                <a
                  href={linkedinLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <BsLinkedin className="icne" />
                </a>
              ) : null}

              {Facebook ? (
                <a href={Facebook} target="_blank" rel="noopener noreferrer">
                  <FaFacebook className="icne" />
                </a>
              ) : null}

              {Instagram ? (
                <a href={Instagram} target="_blank" rel="noopener noreferrer">
                  <FaInstagramSquare className="icne" />
                </a>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
